type FooterApiItem = {
  data?: {
    footer?: {
      key?: string;
      title?: string;
      visible?: boolean;
      cta?: Array<{
        layout?: {
          key?: string;
          visible?: boolean;
          content?: Array<{
            headerSection?: {
              key?: string;
              type?: string;
              title?: string;
              author?: string;
              imgAlt?: string;
              imgLogo?: string;
              status?: string;
              visible?: boolean;
            };
            footerLeft?: {
              key?: string;
              type?: string;
              title?: string;
              author?: string;
              status?: string;
              visible?: boolean;
            };
            footerRight?: {
              key?: string;
              type?: string;
              lists?: Array<{
                id?: number;
                title?: string;
              }>;
              author?: string;
              status?: string;
              visible?: boolean;
            };
          }>;
        };
      }>;
    };
  };
};

export type NormalizedFooter = {
  page: "footer";
  title: string;
  visible: boolean;
  footerLayout: {
    visible: boolean;
  };
  footerHeader: {
    title: string;
    imgAlt: string;
    imgLogo: string;
    visible: boolean;
  };
  footerLeft: {
    title: string;
    visible: boolean;
  };
  footerRight: {
    visible: boolean;
    lists: Array<{
      id: number;
      title: string;
    }>;
  };
  meta: {
    key: string;
  };
};

export function normalizeFooter(item: FooterApiItem): NormalizedFooter | null {
  const footer = item?.data?.footer;
  const layout = footer?.cta?.[0]?.layout;
  const content = layout?.content?.[0];

  if (!footer || !layout || !content) return null;

  return {
    page: "footer",
    title: footer.title ?? "",
    visible: Boolean(footer.visible),

    footerLayout: {
      visible: Boolean(layout.visible),
    },

    footerHeader: {
      title: content.headerSection?.title ?? "",
      imgAlt: content.headerSection?.imgAlt ?? "",
      imgLogo: content.headerSection?.imgLogo ?? "",
      visible: Boolean(content.headerSection?.visible),
    },

    footerLeft: {
      title: content.footerLeft?.title ?? "",
      visible: Boolean(content.footerLeft?.visible),
    },

    footerRight: {
      visible: Boolean(content.footerRight?.visible),
      lists: (content.footerRight?.lists ?? []).map((list) => ({
        id: Number(list.id ?? 0),
        title: list.title ?? "",
      })),
    },

    meta: {
      key: footer.key ?? "",
    },
  };
}